import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { BusinessRole } from 'src/constants/user';
import { ClearVerifyStaffPageClearVerifyAdmin } from 'src/pages/clearVerifyStaff';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <ClearVerifyStaffPageClearVerifyAdmin />,
    accessRoles: [BusinessRole.PlatformAdmin],
  },
];

export const CLEARVERIFY_STAFF_ROUTE: RouteProps = {
  path: appRoutes.clearVerifyStaff.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [BusinessRole.PlatformAdmin],
};
